<div class="buhobox_app" *ngIf="(authService.user | async)">
  <header>
    <div class="container">
      <a class="navbar-brand" href="#"><img src="../assets/img/buhobox_header_top.jpg"></a>
      <nav>
        <ul>
          <li><a href="#" routerLink="/">Hem</a></li>
          <li><a href="#" routerLink="/read_class">Läs in klass</a></li>        
          <li><a href="#" routerLink="/sociogram">Sociogram</a></li>     
          <li><a href="#" routerLink="/graph">Diagram</a></li>     
          <li><a href="#" (click)="logout()">Logga ut</a></li>     
        </ul>
      </nav>
    </div>
  </header>

  <div class="container">
    <router-outlet></router-outlet>
  </div>

  
</div>

<div class="login-frame" *ngIf="!(authService.user | async)">
  <div class="login-img">
    <img src="../assets/img/buhobox_header_top.jpg">
  </div>
  <div class="input">
    <input type="text" [(ngModel)]="email" placeholder="email">
  </div>
  <div class="input">
    <input type="password" [(ngModel)]="password" placeholder="email">
  </div>
  
  <button (click)="login()">
    Login
  </button>
</div>

